import {
  serializeToDisplay,
  type LatexDocument,
  type LatexNode,
} from "@ever-tutor/et-ui";

import { renderMath } from "@/utils/mathjax";

const isSpaceNode = (node: LatexNode) =>
  node.type === "text" && (node as { value?: string }).value === " ";

export const renderStaticDocument = (
  el: HTMLElement,
  doc: LatexDocument,
): void => {
  const segments: LatexNode[][] = [];
  let current: LatexNode[] = [];

  doc.nodes.forEach((node) => {
    if (isSpaceNode(node)) {
      segments.push(current);
      current = [];
      return;
    }
    current.push(node);
  });
  segments.push(current);

  if (segments.length <= 1) {
    renderMath(el, serializeToDisplay(doc));
    return;
  }

  el.innerHTML = "";
  segments.forEach((segment, index) => {
    if (segment.length > 0) {
      const word = document.createElement("span");
      word.className = "et-word-group";
      renderMath(word, serializeToDisplay({ ...doc, nodes: segment }));
      el.appendChild(word);
    }
    if (index < segments.length - 1) {
      const space = document.createElement("span");
      space.className = "et-editing-space";
      space.textContent = " ";
      el.appendChild(space);
    }
  });
};
